<template>
  <b-row class="summary no-gutters">
    <b-col class="tool-border" cols="12">
      <b-col class="reduce-padding" cols="12">
        <wlpHeader :pageTitle="pageTitle"></wlpHeader>
      </b-col>
      <b-col class="page-background-gradient reduce-padding" cols="12">
        <b-row class="page-content no-gutters">
          <b-row class="body-sec no-gutters">
            <b-col colx="!2" class="reduce-padding">
              <b-row class="no-gutters">
                <b-col class="left-col xs-sec" lg="5">
                  <b-row class="no-gutters left-risk-sec">
                    <b-col class="reduce-padding" lg="9" cols="8">
                      <div
                        class="main-risk-text"
                        :class="{ 'main-risk-text-sp': $i18n.locale == 'sp' }"
                      >
                        {{ $t("summary.summary1Title") }}<sup>*</sup
                        ><span v-if="$i18n.locale == 'en'">:</span>
                      </div>
                      <div v-if="$i18n.locale == 'sp'" class="sub-risk-text-sp">
                        {{ $t("summary.cl") }}: {{ $t("summary.interval") }}
                      </div>
                    </b-col>
                    <b-col class="reduce-padding" lg="3" cols="4">
                      <div class="main-risk-textbmi">
                        {{ $t("common.bmi") }}: {{ userData.bmi }}
                      </div>
                    </b-col>
                  </b-row>
                  <!--CURRENT VALUES-->
                  <div class="disease-main-sec2">
                    <b-col class="reduce-padding end-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="ribbon-icon"></div>
                              <div class="icon-label">
                                {{ $t("common.cancer") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19">
                              {{
                                userData.calc.cancer.current
                                  | getMaskedVal("cancer")
                              }}
                              {{ $t("summary.OR") }}
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.cancer.current[0]
                                    | confIntvl
                                }}-{{
                                  userData.confInt.cancer.current[1] | confIntvl
                                }}
                                {{ $t("summary.OR") }})</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col class="reduce-padding main-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="hyperlipidemia-icon"></div>
                              <div class="icon-label">
                                {{ $t("common.dyslipidemia") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19"
                              >{{
                                userData.calc.dyslip.current
                                  | getMaskedVal("hyplip")
                              }}%
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.dyslip.current[0]
                                    | confIntvl
                                }}-{{
                                  userData.confInt.dyslip.current[1]
                                    | confIntvl
                                }}%)</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col class="reduce-padding main-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="hypertension-icon"></div>
                              <div class="icon-label hypertension-label">
                                {{ $t("common.hypertension") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19">
                              {{
                                userData.calc.hypten.current
                                  | getMaskedVal("hypten")
                              }}%
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.hypten.current[0]
                                }}-{{
                                  userData.confInt.hypten.current[1]
                                }}%)</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col class="reduce-padding main-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col infertility" lg="9">
                          <b-row class="no-gutters">
                            <b-col
                              cols="12"
                              :class="{
                                'opacity-div': userData.gender == 'Male',
                              }"
                            >
                              <div class="infertility-icon"></div>
                              <div class="icon-label infertility-label">
                                <div v-if="$i18n.locale == 'sp'">
                                  {{ $t("common.infertility") }}
                                  <span class="pcos"> (PCOS)</span>
                                </div>

                                <div v-if="$i18n.locale == 'en'">Infertility (PCOS)</div>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{
                              'na-value':
                                (userData.gender !== 'Male' &&
                                  Number(userData.bmi) < 20) ||
                                userData.gender == 'Male',
                            }"
                          >
                            <span
                              v-if="
                                userData.gender !== 'Male' &&
                                Number(userData.bmi) < 20
                              "
                              >N/A</span
                            >
                            <span
                              v-if="userData.gender == 'Male'"
                              class="opacity-div"
                              >N/A</span
                            >
                            <span v-if="Number(userData.bmi) > 19">
                              <span v-if="userData.gender == 'Female'"
                                >{{
                                  userData.calc.pcos.current
                                    | getMaskedVal("pcos")
                                }}
                                {{ $t("summary.OR") }}
                                <span class="ci-text"
                                  >{{ $t("summary.cl") }}: ({{
                                    userData.confInt.pcos.current[0]
                                      | confIntvl
                                  }}-{{
                                    userData.confInt.pcos.current[1] | confIntvl
                                  }}
                                  {{ $t("summary.OR") }})</span
                                >
                              </span>
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col
                      v-if="$i18n.locale == 'sp'"
                      class="reduce-padding main-row-height"
                      cols="12"
                    >
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="nafld-icon"></div>
                              <div class="icon-label nafld-label">
                                {{ $t("common.NAFLD") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19">
                              {{
                                userData.calc.nafld.current
                                  | getMaskedVal("nafld")
                              }}%
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.nafld.current[0] | confIntvl
                                }}-{{
                                  userData.confInt.nafld.current[1] | confIntvl
                                }}%)</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col class="reduce-padding main-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="osteoarthritis-icon"></div>
                              <div class="icon-label osteo-label">
                                {{ $t("common.osteoarthritis") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19">
                              {{
                                userData.calc.osteoarth.current
                                  | getMaskedVal("osteoarth")
                              }}
                              {{ $t("summary.OR") }}
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.osteoarth.current[0]
                                    | confIntvl
                                }}-{{
                                  userData.confInt.osteoarth.current[1]
                                    | confIntvl
                                }}
                                {{ $t("summary.OR") }})</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col class="reduce-padding main-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="type2-icon"></div>
                              <div class="icon-label osteo-label">
                                {{ $t("common.diabetes") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19">
                              {{
                                userData.calc.diab.current
                                  | getMaskedVal("diab")
                              }}%
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.diab.current[0] | confIntvl
                                }}-{{
                                  userData.confInt.diab.current[1] | confIntvl
                                }}%)</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                    </b-col>

                    <b-col class="reduce-padding first-row-height" cols="12">
                      <b-row class="no-gutters common-row">
                        <b-col class="left-diseases-col" lg="9">
                          <b-row class="no-gutters">
                            <b-col cols="12">
                              <div class="yearsLost-icon"></div>
                              <div class="icon-label osteo-label">
                                {{ $t("summary.lifeLost") }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          class="reduce-padding right-diseases-col safari_only"
                          lg="3"
                        >
                          <div
                            class="or-value grey-or"
                            :class="{ 'na-value': Number(userData.bmi) < 20 }"
                          >
                            <span v-if="Number(userData.bmi) < 20">N/A</span>
                            <span v-if="Number(userData.bmi) > 19">
                              {{
                                userData.calc.yearsLost.current[0]
                                  | getMaskedVal("yll")
                              }}
                              <span class="ci-text"
                                >{{ $t("summary.cl") }}: ({{
                                  userData.confInt.yearsLost.current[0]
                                    | confIntvl
                                }}-{{
                                  userData.confInt.yearsLost.current[1]
                                    | confIntvl
                                }})</span
                              >
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </div>
                </b-col>

                <b-col class="right-col safari_only" lg="7">
                  <div class="percent-area"></div>
                  <b-tabs class="bmi-tabs">
                    <!--tab 1-->
                    <b-tab
                      class="bmi-tab-5"
                      :title="columnTitle + ': ' + userData.calc.bmi.adj5"
                      active
                    >
                      <b-row class="no-gutters">
                        <b-col cols="12" class="reduce-padding">
                          <b-row class="tab1-sec no-gutters">
                            <div
                              class="disease-main-sec xs-low-sec reduce-border-left"
                            >
                              <b-row class="no-gutters inner-col-tabs">
                                <b-col
                                  class="reduce-padding end-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="{
                                          'green-val':
                                            parseFloat(
                                              userData.calc.cancer.adj5
                                            ) <= 2,
                                          'yellow-val':
                                            parseFloat(
                                              userData.calc.cancer.adj5
                                            ) > 2 &&
                                            parseFloat(
                                              userData.calc.cancer.adj5
                                            ) <= 3,
                                          'orange-val':
                                            parseFloat(
                                              userData.calc.cancer.adj5
                                            ) > 3 &&
                                            parseFloat(
                                              userData.calc.cancer.adj5
                                            ) <= 4,
                                          'red-val':
                                            parseFloat(
                                              userData.calc.cancer.adj5
                                            ) > 4,
                                          'grey-val':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                          'na-value':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                        }"
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                          >{{
                                            userData.calc.cancer.adj5
                                              | getMaskedVal("cancer")
                                          }}
                                          {{ $t("summary.OR") }}
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.cancer.adj5[0]
                                                | confIntvl
                                            }}-{{
                                              userData.confInt.cancer.adj5[1]
                                                | confIntvl
                                            }}
                                            {{ $t("summary.OR") }})</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  class="reduce-padding main-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="
                                          getcolorClassVals(
                                            userData.calc.dyslip.adj5,
                                            '5'
                                          )
                                        "
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          {{
                                            userData.calc.dyslip.adj5
                                              | getMaskedVal("hyplip")
                                          }}%
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.dyslip.adj5[0]
                                                | confIntvl
                                            }}-{{
                                              userData.confInt.dyslip.adj5[1]
                                                | confIntvl
                                            }}%)</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  class="reduce-padding main-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="{
                                          'green-val':
                                            parseInt(
                                              userData.calc.hypten.adj5
                                            ) <= 25,
                                          'yellow-val':
                                            parseInt(
                                              userData.calc.hypten.adj5
                                            ) > 25 &&
                                            parseInt(
                                              userData.calc.hypten.adj5
                                            ) <= 50,
                                          'orange-val':
                                            parseInt(
                                              userData.calc.hypten.adj5
                                            ) > 50 &&
                                            parseInt(
                                              userData.calc.hypten.adj5
                                            ) <= 75,
                                          'red-val':
                                            parseInt(
                                              userData.calc.hypten.adj5
                                            ) > 75,
                                          'grey-val':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                          'na-value':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                        }"
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          {{
                                            userData.calc.hypten.adj5
                                              | getMaskedVal("hypten")
                                          }}%
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.hypten.adj5[0]
                                            }}-{{
                                              userData.confInt.hypten.adj5[1]
                                            }}%)</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  class="reduce-padding main-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      :class="{
                                        'na-value-col':
                                          userData.gender == 'Male' ||
                                          (userData.gender !== 'Male' &&
                                            (Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj5) <
                                                20)),
                                      }"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="
                                          getcolorClassInfertitlity(
                                            0,
                                            userData.calc.pcos.adj5,
                                            '5'
                                          )
                                        "
                                      >
                                        <span
                                          v-if="
                                            userData.gender !== 'Male' &&
                                            (Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj5) <
                                                20)
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="userData.gender == 'Male'"
                                          class="opacity-div"
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          <span
                                            v-if="userData.gender == 'Female'"
                                            >{{
                                              userData.calc.pcos.adj5
                                                | getMaskedVal("pcos")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.pcos.adj5[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.pcos.adj5[1]
                                                  | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            ></span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  v-if="$i18n.locale == 'sp'"
                                  class="reduce-padding main-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="{
                                          'green-val':
                                            parseInt(
                                              userData.calc.nafld.adj5
                                            ) <= 25,
                                          'yellow-val':
                                            parseInt(userData.calc.nafld.adj5) >
                                              25 &&
                                            parseInt(
                                              userData.calc.nafld.adj5
                                            ) <= 50,
                                          'orange-val':
                                            parseInt(userData.calc.nafld.adj5) >
                                              50 &&
                                            parseInt(
                                              userData.calc.nafld.adj5
                                            ) <= 75,
                                          'red-val':
                                            parseInt(userData.calc.nafld.adj5) >
                                            75,
                                          'grey-val':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                          'na-value':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                        }"
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          {{
                                            userData.calc.nafld.adj5
                                              | getMaskedVal("nafld")
                                          }}%
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.nafld.adj5[0]
                                                | confIntvl
                                            }}-{{
                                              userData.confInt.nafld.adj5[1]
                                                | confIntvl
                                            }}%)</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  class="reduce-padding main-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="{
                                          'green-val':
                                            parseFloat(
                                              userData.calc.osteoarth.adj5
                                            ) <= 2,
                                          'yellow-val':
                                            parseFloat(
                                              userData.calc.osteoarth.adj5
                                            ) > 2 &&
                                            parseFloat(
                                              userData.calc.osteoarth.adj5
                                            ) <= 3,
                                          'orange-val':
                                            parseFloat(
                                              userData.calc.osteoarth.adj5
                                            ) > 3 &&
                                            parseFloat(
                                              userData.calc.osteoarth.adj5
                                            ) <= 4,
                                          'red-val':
                                            parseFloat(
                                              userData.calc.osteoarth.adj5
                                            ) > 4,
                                          'grey-val':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                          'na-value':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                        }"
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          {{
                                            userData.calc.osteoarth.adj5
                                              | getMaskedVal("osteoarth")
                                          }}
                                          {{ $t("summary.OR") }}
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.osteoarth.adj5[0]
                                                | confIntvl
                                            }}-{{
                                              userData.confInt.osteoarth.adj5[1]
                                                | confIntvl
                                            }}
                                            {{ $t("summary.OR") }})</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  class="reduce-padding main-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="{
                                          'green-val':
                                            parseInt(userData.calc.diab.adj5) <=
                                            25,
                                          'yellow-val':
                                            parseInt(userData.calc.diab.adj5) >
                                              25 &&
                                            parseInt(userData.calc.diab.adj5) <=
                                              50,
                                          'orange-val':
                                            parseInt(userData.calc.diab.adj5) >
                                              50 &&
                                            parseInt(userData.calc.diab.adj5) <=
                                              75,
                                          'red-val':
                                            parseInt(userData.calc.diab.adj5) >
                                            75,
                                          'grey-val':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                          'na-value':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                        }"
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          {{
                                            userData.calc.diab.adj5
                                              | getMaskedVal("diab")
                                          }}%
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.diab.adj5[0]
                                                | confIntvl
                                            }}-{{
                                              userData.confInt.diab.adj5[1]
                                                | confIntvl
                                            }}%)</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <hr />
                                </b-col>

                                <b-col
                                  class="reduce-padding first-row-height"
                                  cols="12"
                                >
                                  <b-row class="no-gutters common-row">
                                    <b-col
                                      class="reduce-padding right-diseases-col"
                                      cols="12"
                                    >
                                      <div
                                        class="or-value"
                                        :class="{
                                          'green-val':
                                            parseFloat(
                                              userData.calc.yearsLost.adj5
                                            ) <= 1,
                                          'yellow-val':
                                            parseFloat(
                                              userData.calc.yearsLost.adj5
                                            ) > 1 &&
                                            parseFloat(
                                              userData.calc.yearsLost.adj5
                                            ) <= 2,
                                          'orange-val':
                                            parseFloat(
                                              userData.calc.yearsLost.adj5
                                            ) > 2 &&
                                            parseFloat(
                                              userData.calc.yearsLost.adj5
                                            ) <= 3,
                                          'red-val':
                                            parseFloat(
                                              userData.calc.yearsLost.adj5
                                            ) > 3,
                                          'grey-val':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                          'na-value':
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20,
                                        }"
                                      >
                                        <span
                                          v-if="
                                            Number(userData.bmi) < 20 ||
                                            Number(userData.calc.bmi.adj5) < 20
                                          "
                                          >N/A</span
                                        >
                                        <span
                                          v-if="
                                            Number(userData.bmi) > 19 &&
                                            Number(userData.calc.bmi.adj5) > 19
                                          "
                                        >
                                          {{
                                            userData.calc.yearsLost.adj5[0]
                                              | getMaskedVal("yll")
                                          }}
                                          <span class="ci-text"
                                            >{{ $t("summary.cl") }}: ({{
                                              userData.confInt.yearsLost.adj5[0]
                                                | confIntvl
                                            }}-{{
                                              userData.confInt.yearsLost.adj5[1]
                                                | confIntvl
                                            }})</span
                                          >
                                        </span>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </div>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-tab>

                    <!--tab2-->
                    <b-tab
                      :title="columnTitle + ': ' + userData.calc.bmi.adj10"
                    >
                      <div class="slider-div-summary">
                        <b-row class="no-gutters">
                          <b-col cols="12" class="reduce-padding">
                            <b-row class="tab1-sec no-gutters">
                              <div
                                class="disease-main-sec xs-low-sec reduce-border-left"
                              >
                                <b-row class="no-gutters">
                                  <b-col
                                    class="reduce-padding end-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.cancer.adj10
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.cancer.adj10
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.cancer.adj10
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.cancer.adj10
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.cancer.adj10
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.cancer.adj10
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.cancer.adj10
                                                | getMaskedVal("cancer")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.cancer.adj10[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.cancer.adj10[1]
                                                  | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassVals(
                                              userData.calc.dyslip.adj10,
                                              '10'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.dyslip.adj10
                                                | getMaskedVal("hyplip")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.dyslip.adj10[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.dyslip.adj10[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.hypten.adj10
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.hypten.adj10
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.hypten.adj10
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.hypten.adj10
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.hypten.adj10
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.hypten.adj10
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.hypten.adj10
                                                | getMaskedVal("hypten")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.hypten
                                                  .adj10[0]
                                              }}-{{
                                                userData.confInt.hypten
                                                  .adj10[1]
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        :class="{
                                          'na-value-col':
                                            userData.gender == 'Male' ||
                                            (userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj10
                                                ) < 20)),
                                        }"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassInfertitlity(
                                              0,
                                              userData.calc.pcos.adj10,
                                              '10'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj10
                                                ) < 20)
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="userData.gender == 'Male'"
                                            class="opacity-div"
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            <span
                                              v-if="userData.gender == 'Female'"
                                              >{{
                                                userData.calc.pcos.adj10
                                                  | getMaskedVal("pcos")
                                              }}
                                              {{ $t("summary.OR") }}
                                              <span class="ci-text"
                                                >{{ $t("summary.cl") }}: ({{
                                                  userData.confInt.pcos.adj10[0]
                                                    | confIntvl
                                                }}-{{
                                                  userData.confInt.pcos.adj10[1]
                                                    | confIntvl
                                                }}
                                                {{ $t("summary.OR") }})</span
                                              >
                                            </span>
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    v-if="$i18n.locale == 'sp'"
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.nafld.adj10
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.nafld.adj10
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.nafld.adj10
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.nafld.adj10
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.nafld.adj10
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.nafld.adj10
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.nafld.adj10
                                                | getMaskedVal("nafld")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.nafld.adj10[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.nafld.adj10[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj10
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj10
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj10
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj10
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj10
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj10
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.osteoarth.adj10
                                                | getMaskedVal("osteoarth")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.osteoarth
                                                  .adj10[0] | confIntvl
                                              }}-{{
                                                userData.confInt.osteoarth
                                                  .adj10[1] | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.diab.adj10
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.diab.adj10
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.diab.adj10
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.diab.adj10
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.diab.adj10
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.diab.adj10
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.diab.adj10
                                                | getMaskedVal("diab")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.diab.adj10[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.diab.adj10[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding first-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin"
                                    >
                                      <b-col
                                        class="reduce-padding right-col-sm-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="9"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj10
                                              ) <= 1,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj10
                                              ) > 1 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj10
                                              ) <= 2,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj10
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj10
                                              ) <= 3,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj10
                                              ) > 3,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj10) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj10) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.yearsLost.adj10[0]
                                                | getMaskedVal("yll")
                                            }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.yearsLost
                                                  .adj10[0] | confIntvl
                                              }}-{{
                                                userData.confInt.yearsLost
                                                  .adj10[1] | confIntvl
                                              }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-row>
                          </b-col>
                        </b-row>
                      </div>
                    </b-tab>

                    <!--tab3-->
                    <b-tab
                      :title="columnTitle + ': ' + userData.calc.bmi.adj15"
                    >
                      <div class="slider-div-summary">
                        <b-row class="no-gutters">
                          <b-col cols="12" class="reduce-padding">
                            <b-row class="tab1-sec no-gutters">
                              <div
                                class="disease-main-sec xs-low-sec reduce-border-left"
                              >
                                <b-row class="no-gutters">
                                  <b-col
                                    class="reduce-padding end-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.cancer.adj15
                                                | getMaskedVal("cancer")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.cancer.adj15[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.cancer.adj15[1]
                                                  | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding end-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.cancer.adj15
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.cancer.adj15
                                                | getMaskedVal("cancer")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.cancer.adj15[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.cancer.adj15[1]
                                                  | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassVals(
                                              userData.calc.dyslip.adj15,
                                              '15'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.dyslip.adj15
                                                | getMaskedVal("hyplip")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.dyslip.adj15[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.dyslip.adj15[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassVals(
                                              userData.calc.dyslip.adj15,
                                              '15'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.dyslip.adj15
                                                | getMaskedVal("hyplip")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.dyslip.adj15[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.dyslip.adj15[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.hypten.adj15
                                                | getMaskedVal("hypten")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.hypten
                                                  .adj15[0]
                                              }}-{{
                                                userData.confInt.hypten
                                                  .adj15[1]
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.hypten.adj15
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.hypten.adj15
                                                | getMaskedVal("hypten")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.hypten
                                                  .adj15[0]
                                              }}-{{
                                                userData.confInt.hypten
                                                  .adj15[1]
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        :class="{
                                          'na-value-col':
                                            userData.gender == 'Male' ||
                                            (userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj15
                                                ) < 20)),
                                        }"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassInfertitlity(
                                              0,
                                              userData.calc.pcos.adj15,
                                              '15'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj15
                                                ) < 20)
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="userData.gender == 'Male'"
                                            class="opacity-div"
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            <span
                                              v-if="userData.gender == 'Female'"
                                              >{{
                                                userData.calc.pcos.adj15
                                                  | getMaskedVal("pcos")
                                              }}
                                              {{ $t("summary.OR") }}
                                              <span class="ci-text"
                                                >{{ $t("summary.cl") }}: ({{
                                                  userData.confInt.pcos.adj15[0]
                                                    | confIntvl
                                                }}-{{
                                                  userData.confInt.pcos.adj15[1]
                                                    | confIntvl
                                                }}
                                                {{ $t("summary.OR") }})</span
                                              >
                                            </span>
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        :class="{
                                          'na-value-col':
                                            userData.gender == 'Male' ||
                                            (userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj15
                                                ) < 20)),
                                        }"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassInfertitlity(
                                              0,
                                              userData.calc.pcos.adj15,
                                              '15'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj15
                                                ) < 20)
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="userData.gender == 'Male'"
                                            class="opacity-div"
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            <span
                                              v-if="userData.gender == 'Female'"
                                              >{{
                                                userData.calc.pcos.adj15
                                                  | getMaskedVal("pcos")
                                              }}
                                              {{ $t("summary.OR") }}
                                              <span class="ci-text"
                                                >{{ $t("summary.cl") }}: ({{
                                                  userData.confInt.pcos.adj15[0]
                                                    | confIntvl
                                                }}-{{
                                                  userData.confInt.pcos.adj15[1]
                                                    | confIntvl
                                                }}
                                                {{ $t("summary.OR") }})</span
                                              >
                                            </span>
                                          </span>
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    v-if="$i18n.locale == 'sp'"
                                    class="reduce-padding main-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div class="or-value grey-val na-value">
                                          N/A
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                  v-if="$i18n.locale == 'sp'" 
                                    class="reduce-padding main-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div class="or-value grey-val na-value">
                                          N/A
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.osteoarth.adj15
                                                | getMaskedVal("osteoarth")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.osteoarth
                                                  .adj15[0] | confIntvl
                                              }}-{{
                                                userData.confInt.osteoarth
                                                  .adj15[1] | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj15
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.osteoarth.adj15
                                                | getMaskedVal("osteoarth")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.osteoarth
                                                  .adj15[0] | confIntvl
                                              }}-{{
                                                userData.confInt.osteoarth
                                                  .adj15[1] | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.diab.adj15
                                                | getMaskedVal("diab")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.diab.adj15[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.diab.adj15[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.diab.adj15
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.diab.adj15
                                                | getMaskedVal("diab")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.diab.adj15[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.diab.adj15[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding first-row-height div-lg"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin4"
                                    >
                                      <b-col
                                        class="reduce-padding"
                                        cols="6"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) <= 1,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) > 1 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) <= 2,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) <= 3,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) > 3,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.yearsLost.adj15[0]
                                                | getMaskedVal("yll")
                                            }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.yearsLost
                                                  .adj15[0] | confIntvl
                                              }}-{{
                                                userData.confInt.yearsLost
                                                  .adj15[1] | confIntvl
                                              }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </b-col>

                                  <b-col
                                    class="reduce-padding first-row-height div-xs"
                                    cols="12"
                                  >
                                    <b-row class="no-gutters common-row">
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="6"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) <= 1,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) > 1 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) <= 2,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) <= 3,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj15
                                              ) > 3,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj15) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj15) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.yearsLost.adj15[0]
                                                | getMaskedVal("yll")
                                            }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.yearsLost
                                                  .adj15[0] | confIntvl
                                              }}-{{
                                                userData.confInt.yearsLost
                                                  .adj15[1] | confIntvl
                                              }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-text"
                                        cols="6"
                                      ></b-col>
                                    </b-row>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-row>
                          </b-col>
                        </b-row>
                      </div>
                    </b-tab>

                    <!--tab4-->
                    <b-tab
                      class="last-tab"
                      :title="columnTitle + ': ' + userData.calc.bmi.adj20"
                    >
                      <div class="slider-div-summary">
                        <b-row class="no-gutters">
                          <b-col cols="12" class="reduce-padding">
                            <b-row class="tab1-sec no-gutters">
                              <div
                                class="disease-main-sec xs-low-sec reduce-border-left"
                              >
                                <b-row class="margin-left-tab4 no-gutters">
                                  <b-col
                                    class="reduce-padding end-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.cancer.adj20
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.cancer.adj20
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.cancer.adj20
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.cancer.adj20
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.cancer.adj20
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.cancer.adj20
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.cancer.adj20
                                                | getMaskedVal("cancer")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.cancer.adj20[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.cancer.adj20[1]
                                                  | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassVals(
                                              userData.calc.dyslip.adj20,
                                              '20'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.dyslip.adj20
                                                | getMaskedVal("hyplip")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.dyslip.adj20[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.dyslip.adj20[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.hypten.adj20
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.hypten.adj20
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.hypten.adj20
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.hypten.adj20
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.hypten.adj20
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.hypten.adj20
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.hypten.adj20
                                                | getMaskedVal("hypten")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.hypten
                                                  .adj20[0]
                                              }}-{{
                                                userData.confInt.hypten
                                                  .adj20[1]
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        :class="{
                                          'na-value-col':
                                            userData.gender == 'Male' ||
                                            (userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj20
                                                ) < 20)),
                                        }"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="
                                            getcolorClassInfertitlity(
                                              0,
                                              userData.calc.pcos.adj20,
                                              '20'
                                            )
                                          "
                                        >
                                          <span
                                            v-if="
                                              userData.gender !== 'Male' &&
                                              (Number(userData.bmi) < 20 ||
                                                Number(
                                                  userData.calc.bmi.adj20
                                                ) < 20)
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="userData.gender == 'Male'"
                                            class="opacity-div"
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            <span
                                              v-if="userData.gender == 'Female'"
                                              >{{
                                                userData.calc.pcos.adj20
                                                  | getMaskedVal("pcos")
                                              }}
                                              {{ $t("summary.OR") }}
                                              <span class="ci-text"
                                                >{{ $t("summary.cl") }}: ({{
                                                  userData.confInt.pcos.adj20[0]
                                                    | confIntvl
                                                }}-{{
                                                  userData.confInt.pcos.adj20[1]
                                                    | confIntvl
                                                }}
                                                {{ $t("summary.OR") }})</span
                                              >
                                            </span>
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    v-if="$i18n.locale == 'sp'"
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div class="or-value grey-val na-value">
                                          N/A
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj20
                                              ) <= 2,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj20
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj20
                                              ) <= 3,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj20
                                              ) > 3 &&
                                              parseFloat(
                                                userData.calc.osteoarth.adj20
                                              ) <= 4,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.osteoarth.adj20
                                              ) > 4,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.osteoarth.adj20
                                                | getMaskedVal("osteoarth")
                                            }}
                                            {{ $t("summary.OR") }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.osteoarth
                                                  .adj20[0] | confIntvl
                                              }}-{{
                                                userData.confInt.osteoarth
                                                  .adj20[1] | confIntvl
                                              }}
                                              {{ $t("summary.OR") }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding main-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseInt(
                                                userData.calc.diab.adj20
                                              ) <= 25,
                                            'yellow-val':
                                              parseInt(
                                                userData.calc.diab.adj20
                                              ) > 25 &&
                                              parseInt(
                                                userData.calc.diab.adj20
                                              ) <= 50,
                                            'orange-val':
                                              parseInt(
                                                userData.calc.diab.adj20
                                              ) > 50 &&
                                              parseInt(
                                                userData.calc.diab.adj20
                                              ) <= 75,
                                            'red-val':
                                              parseInt(
                                                userData.calc.diab.adj20
                                              ) > 75,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.diab.adj20
                                                | getMaskedVal("diab")
                                            }}%
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.diab.adj20[0]
                                                  | confIntvl
                                              }}-{{
                                                userData.confInt.diab.adj20[1]
                                                  | confIntvl
                                              }}%)</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <hr />
                                  </b-col>

                                  <b-col
                                    class="reduce-padding first-row-height"
                                    cols="12"
                                  >
                                    <b-row
                                      class="no-gutters common-row left-margin5"
                                    >
                                      <b-col
                                        class="reduce-padding div-lg"
                                        cols="9"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-col-sm-xs div-xs"
                                        cols="3"
                                      ></b-col>
                                      <b-col
                                        class="reduce-padding right-text div-xs"
                                        cols="3"
                                      >
                                      </b-col>
                                      <b-col
                                        class="reduce-padding right-diseases-col"
                                        cols="3"
                                      >
                                        <div
                                          class="or-value"
                                          :class="{
                                            'green-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj20
                                              ) <= 1,
                                            'yellow-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj20
                                              ) > 1 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj20
                                              ) <= 2,
                                            'orange-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj20
                                              ) > 2 &&
                                              parseFloat(
                                                userData.calc.yearsLost.adj20
                                              ) <= 3,
                                            'red-val':
                                              parseFloat(
                                                userData.calc.yearsLost.adj20
                                              ) > 3,
                                            'grey-val':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                            'na-value':
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20,
                                          }"
                                        >
                                          <span
                                            v-if="
                                              Number(userData.bmi) < 20 ||
                                              Number(userData.calc.bmi.adj20) <
                                                20
                                            "
                                            >N/A</span
                                          >
                                          <span
                                            v-if="
                                              Number(userData.bmi) > 19 &&
                                              Number(userData.calc.bmi.adj20) >
                                                19
                                            "
                                          >
                                            {{
                                              userData.calc.yearsLost.adj20[0]
                                                | getMaskedVal("yll")
                                            }}
                                            <span class="ci-text"
                                              >{{ $t("summary.cl") }}: ({{
                                                userData.confInt.yearsLost
                                                  .adj20[0] | confIntvl
                                              }}-{{
                                                userData.confInt.yearsLost
                                                  .adj20[1] | confIntvl
                                              }})</span
                                            >
                                          </span>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-row>
                          </b-col>
                        </b-row>
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-col>

                <b-col class="reduce-padding" cols="12">
                  <b-row class="no-gutters">
                    <b-col class="reduce-padding" lg="6" cols="12">
                      <div v-if="$i18n.locale == 'en'" class="sub-risk-text">
                        {{ $t("summary.cl") }}: {{ $t("summary.interval") }}
                      </div>
                      <div
                        v-if="$i18n.locale == 'en'"
                        class="sub-risk-text ci-text2"
                      >
                        Confident intervals represent projected range.
                      </div>
                    </b-col>
                    <b-col class="reduce-padding" lg="6" cols="12">
                      <div
                        :class="{ 'adj-bottom-txt-sp': $i18n.locale == 'sp' }"
                        class="adj-bottom-txt"
                      >
                        <sup>*</sup><i>{{ $t("weightAdjBox.footer") }}</i>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-row>
        <wlpNavigation
          :navButtons="['info', 'references', 'tnc', 'menu', 'back', 'next']"
          :currentScreen="10"
        ></wlpNavigation>
      </b-col>
    </b-col>
  </b-row>
</template>
<script>
/* eslint-disable */
import scrollMixin from "../mixins/scrollMixin";
import wlpHeader from "../components/wlpHeader.vue";
import wlpNavigation from "../components/wlpNavigation.vue";
import { mapGetters } from "vuex";
export default {
  name: "summary1",
  mixins: [scrollMixin],
  mounted: function () {
    this.scrollToTop();
  },
  components: {
    wlpHeader: wlpHeader,
    wlpNavigation: wlpNavigation,
  },
  computed: {
    ...mapGetters("userData", ["userData"]),
  },
  data() {
    return {
      pageTitle: this.$t("summary.pageTitle"),
      columnTitle: this.$t("common.bmi"),
    };
  },

  created() {},

  filters: {
    getMaskedVal: function (value, disease) {
      switch (disease) {
        case "cancer":
          if (value % 1 == 0) {
            return value + "." + "00";
          } else if (value.toString().split(".")[1].length == 1) {
            return value + "0";
          } else {
            return value;
          }
        case "pcos":
        case "osteoarth":
        case "diab":
        case "yll":
          if (value % 1 == 0) {
            return value + "." + "0";
          } else {
            return value;
          }
        default:
          return value;
      }
    },
    confIntvl: function (value) {
      if (value % 1 == 0 && value !== 0) {
        return value + "." + "0";
      } else {
        return value;
      }
    },
  },

  methods: {
    getcolorClassVals(value2, v) {
      if (v == "current") {
        return {
          "green-val": parseFloat(value2) >= 60,
          "yellow-val": parseFloat(value2) > 39 && parseFloat(value2) <= 59,
          "red-val": parseFloat(value2) <= 40,
          "grey-val na-value": Number(this.userData.bmi) < 20,
          singlemm: Number(this.userData.bmi) < 20,
        };
      } else if (v == "5") {
        return {
          "green-val": parseFloat(value2) >= 60,
          "yellow-val": parseFloat(value2) > 39 && parseFloat(value2) <= 59,
          "red-val": parseFloat(value2) <= 40,
          "grey-val na-value": Number(this.userData.calc.bmi.adj5) < 20,
          singlemm: Number(this.userData.calc.bmi.adj5) < 20,
        };
      } else if (v == "10") {
        return {
          "green-val": parseFloat(value2) >= 60,
          "yellow-val": parseFloat(value2) > 39 && parseFloat(value2) <= 59,
          "red-val": parseFloat(value2) <= 40,
          "grey-val na-value": Number(this.userData.calc.bmi.adj10) < 20,
          singlemm: Number(this.userData.calc.bmi.adj10) < 20,
        };
      } else if (v == "15") {
        return {
          "green-val": parseFloat(value2) >= 60,
          "yellow-val": parseFloat(value2) > 39 && parseFloat(value2) <= 59,
          "red-val": parseFloat(value2) <= 40,
          "grey-val na-value": Number(this.userData.calc.bmi.adj15) < 20,
          singlemm: Number(this.userData.calc.bmi.adj15) < 20,
        };
      } else if (v == "20") {
        return {
          "green-val": parseFloat(value2) >= 60,
          "yellow-val": parseFloat(value2) > 39 && parseFloat(value2) <= 59,
          "red-val": parseFloat(value2) <= 40,
          "grey-val na-value": Number(this.userData.calc.bmi.adj20) < 20,
          singlemm: Number(this.userData.calc.bmi.adj20) < 20,
        };
      }
    },

    getcolorClassInfertitlity(value1, value2, v) {
      if (this.userData.gender == "Male") {
        if (v == "current") {
          return {
            "green-val": parseFloat(value1) <= 2,
            "yellow-val": parseFloat(value1) > 2 && parseFloat(value1) <= 3,
            "orange-val": parseFloat(value1) > 3 && parseFloat(value1) <= 4,
            "red-val": parseFloat(value1) > 4,
            "grey-val na-value": parseFloat(value1) == 0,
            "grey-val na-value": Number(this.userData.bmi) < 20,
            singlemm: Number(this.userData.bmi) < 20,
          };
        } else if (v == "5") {
          return {
            "green-val": parseFloat(value1) <= 2,
            "yellow-val": parseFloat(value1) > 2 && parseFloat(value1) <= 3,
            "orange-val": parseFloat(value1) > 3 && parseFloat(value1) <= 4,
            "red-val": parseFloat(value1) > 4,
            "grey-val na-value": parseFloat(value1) == 0,
            "grey-val na-value": Number(this.userData.calc.bmi.adj5) < 20,
            singlemm: Number(this.userData.calc.bmi.adj5) < 20,
          };
        } else if (v == "10") {
          return {
            "green-val": parseFloat(value1) <= 2,
            "yellow-val": parseFloat(value1) > 2 && parseFloat(value1) <= 3,
            "orange-val": parseFloat(value1) > 3 && parseFloat(value1) <= 4,
            "red-val": parseFloat(value1) > 4,
            "grey-val na-value": parseFloat(value1) == 0,
            "grey-val na-value": Number(this.userData.calc.bmi.adj10) < 20,
            singlemm: Number(this.userData.calc.bmi.adj10) < 20,
          };
        } else if (v == "15") {
          return {
            "green-val": parseFloat(value1) <= 2,
            "yellow-val": parseFloat(value1) > 2 && parseFloat(value1) <= 3,
            "orange-val": parseFloat(value1) > 3 && parseFloat(value1) <= 4,
            "red-val": parseFloat(value1) > 4,
            "grey-val na-value": parseFloat(value1) == 0,
            "grey-val na-value": Number(this.userData.calc.bmi.adj15) < 20,
            singlemm: Number(this.userData.calc.bmi.adj15) < 20,
          };
        } else if (v == "20") {
          return {
            "green-val": parseFloat(value1) <= 2,
            "yellow-val": parseFloat(value1) > 2 && parseFloat(value1) <= 3,
            "orange-val": parseFloat(value1) > 3 && parseFloat(value1) <= 4,
            "red-val": parseFloat(value1) > 4,
            "grey-val na-value": parseFloat(value1) == 0,
            "grey-val na-value": Number(this.userData.calc.bmi.adj20) < 20,
            singlemm: Number(this.userData.calc.bmi.adj20) < 20,
          };
        }
      } else if (this.userData.gender == "Female") {
        if (v == "current") {
          return {
            "green-val": parseFloat(value2) <= 2,
            "yellow-val": parseFloat(value2) > 2 && parseFloat(value2) <= 3,
            "orange-val": parseFloat(value2) > 3 && parseFloat(value2) <= 4,
            "red-val": parseFloat(value2) > 4,
            "grey-val na-value": Number(this.userData.bmi) < 20,
            singlemm: Number(this.userData.bmi) < 20,
          };
        } else if (v == "5") {
          return {
            "green-val": parseFloat(value2) <= 2,
            "yellow-val": parseFloat(value2) > 2 && parseFloat(value2) <= 3,
            "orange-val": parseFloat(value2) > 3 && parseFloat(value2) <= 4,
            "red-val": parseFloat(value2) > 4,
            "grey-val na-value": Number(this.userData.calc.bmi.adj5) < 20,
            singlemm: Number(this.userData.calc.bmi.adj5) < 20,
          };
        } else if (v == "10") {
          return {
            "green-val": parseFloat(value2) <= 2,
            "yellow-val": parseFloat(value2) > 2 && parseFloat(value2) <= 3,
            "orange-val": parseFloat(value2) > 3 && parseFloat(value2) <= 4,
            "red-val": parseFloat(value2) > 4,
            "grey-val na-value": Number(this.userData.calc.bmi.adj10) < 20,
            singlemm: Number(this.userData.calc.bmi.adj10) < 20,
          };
        } else if (v == "15") {
          return {
            "green-val": parseFloat(value2) <= 2,
            "yellow-val": parseFloat(value2) > 2 && parseFloat(value2) <= 3,
            "orange-val": parseFloat(value2) > 3 && parseFloat(value2) <= 4,
            "red-val": parseFloat(value2) > 4,
            "grey-val na-value": Number(this.userData.calc.bmi.adj15) < 20,
            singlemm: Number(this.userData.calc.bmi.adj15) < 20,
          };
        } else if (v == "20") {
          return {
            "green-val": parseFloat(value2) <= 2,
            "yellow-val": parseFloat(value2) > 2 && parseFloat(value2) <= 3,
            "orange-val": parseFloat(value2) > 3 && parseFloat(value2) <= 4,
            "red-val": parseFloat(value2) > 4,
            "grey-val na-value": Number(this.userData.calc.bmi.adj20) < 20,
            singlemm: Number(this.userData.calc.bmi.adj20) < 20,
          };
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
